import {
  DriverEmailField,
  DriverIdField,
  DriverLicenseNumberField,
  DriverNameField,
  DriverPhoneField,
} from '@src/permitField/DriverInformationFields';
import * as yup from 'yup';

export const DriverInformationInputsSchema = yup.object().shape(
  {
    [DriverIdField.fieldName]: DriverIdField.validator,
    [DriverNameField.fieldName]: DriverNameField.validator,
    [DriverEmailField.fieldName]: DriverEmailField.validator.when(
      DriverPhoneField.fieldName,
      {
        is: (val: string) => !val,
        then: (schema) => schema.required('emailOrPhoneRequired'),
        otherwise: (schema) => schema.optional(),
      },
    ),
    [DriverPhoneField.fieldName]: DriverPhoneField.validator.when(
      DriverEmailField.fieldName,
      {
        is: (val: string) => !val,
        then: (schema) => schema.required('emailOrPhoneRequired'),
        otherwise: (schema) => schema.optional(),
      },
    ),
    [DriverLicenseNumberField.fieldName]: DriverLicenseNumberField.validator,
  },
  [[DriverPhoneField.fieldName, DriverEmailField.fieldName]],
);
